import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import {
  ControlProps,
  rankWith,
  isDescriptionHidden,
  isDateControl,
} from "@jsonforms/core";
import { useEffect, useState, useRef } from "react";
import PYPFileUploader from "../../../PYPFileUploader";

export const FileUploaderRenderer = ({
  data,
  handleChange,
  path,
  schema,
  visible,
  uischema,
}: ControlProps) => {
  const ctx = useJsonForms();
  const title = schema?.title;
  const titleClassName = uischema?.options?.titleClassName;

  const showOptional = uischema?.options?.showOptional;
  const allowedMimeType = uischema?.options?.allowedMimeType;
  const maxAllowed = uischema?.options?.maxAllowed;
  const showDefaultSVG = uischema?.options?.showDefaultSVG;
  const defaultText = uischema?.options?.defaultText;
  const owner_service_type = uischema?.options?.owner_service_type;
  const property_uuid = ctx?.core?.uischema?.options?.property_uuid;
  const [customError, setCustomError] = useState("");
  const positionRef = useRef<HTMLInputElement>(null);

  let show =
    uischema?.options?.show === undefined ? true : uischema?.options?.show;
  visible = show && visible;
  useEffect(() => {
    if (show == false) {
      handleChange(path, []);
    }
  }, [show]);

  useEffect(() => {
    const errorData = ctx?.core?.errors;
    let flag = false;
    errorData?.forEach((error: any) => {
      if (error?.instancePath === "/" + path) {
        setCustomError(error?.message);
        flag = true;
      } else if (
        error?.instancePath === "" &&
        error?.params?.missingProperty === path
      ) {
        setCustomError("Required Field");
        flag = true;
        return;
      }
    });

    if (!flag) setCustomError("");
    else {
      if (positionRef.current) {
        positionRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  }, [ctx?.core?.errors]);

  return visible ? (
    <div ref={positionRef} className="w-full">
      <p
        className={`font-openSans font-semibold text-mobile-body-lg lg:text-web-subheading leading-[22px] lg:leading-4 ${titleClassName} text-brand-bgBlack uppercase`}
      >
        {schema?.title}
        {showOptional && (
          <span className="text-web-body-md leading-5 text-brand-textLightGrey uppercase ml-1">
            (optional)
          </span>
        )}
      </p>

      <PYPFileUploader
        property_uuid={property_uuid}
        data={data}
        owner_service_type={owner_service_type}
        handleChange={handleChange}
        path={path}
        maxAllowed={maxAllowed}
        allowedMimeTypes={allowedMimeType}
        showDefaultSVG={showDefaultSVG}
        defaultText={defaultText}
      />
      {customError && (
        <label
          htmlFor="name"
          className={"text-brand-textRed text-web-body-sm ml-2"}
        >
          {customError}
        </label>
      )}
    </div>
  ) : (
    <></>
  );
};

export default withJsonFormsControlProps(FileUploaderRenderer);
